import { IcommentItem } from '@typings/common/comment.interface';
import { fuego } from '@nandorojo/swr-firestore';
import { updateGuestbook } from '@store/firebase/guestBook/update-guestbook';
import { updateUserNotification } from '../notification/update-notification';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/firestore';
import { processContentWithBots } from '@utils/customBot.util';
import { emitTimelineForceRefresh } from '@utils/realtimeFallbackEvent';

type Props = {
  data: IcommentItem;
  collectionPath: string;
  commentId?: string;
  guestbook?: boolean;
  sendToMasters?: boolean;
  skipCommentNotification?: boolean;
};

export async function updateComment({
  data,
  collectionPath,
  commentId,
  guestbook,
  sendToMasters,
  skipCommentNotification = false,
}: Props) {
  const ref = fuego.db.collection(`${collectionPath}Comment`);
  const parentRef = fuego.db.collection(collectionPath);

  const serverTs = firebase.firestore.FieldValue.serverTimestamp();

  const newData: IcommentItem = {
    ...data,
    editedAt: serverTs as any,
    updatedAt: serverTs as any,
  } as any;

  if (!commentId && guestbook) {
    // geustbook 추가 수정
    return updateGuestbook({ data, collectionPath, docId: data.boardId });
  }

  if (!commentId) {
    // 댓글 추가

    // 🎯 커스텀 봇 실행 (신규 작성만)
    const { contents: processedContents, botResults } = await processContentWithBots(
      data.contents || '',
      false // 신규 작성이므로 봇 실행
    );

    if (botResults) {
      console.log('🤖 댓글 봇 실행 결과:', botResults);
    }

    // 상위 보드의 업데이트일 수정, 최신유저 수정
    await parentRef
      .doc(data.boardId)
      .set(
        { updatedAt: serverTs, latestAuthor: data.authorUid },
        { merge: true },
      );

    //  댓글 추가 (원본 contents + botResults 별도 저장)
    await ref
      .add({
        ...data,
        contents: processedContents, // 🎯 원본 contents 그대로
        ...(botResults ? { botResults } : {}), // 🎯 봇 결과 별도 저장
        createdAt: serverTs,
        editedAt: serverTs,
        updatedAt: serverTs,
      })
      .then((res) => res.id)
      .catch((err) => console.log(err.message));

    // --------------------------------------
    // 알림 추가 (도전장 배틀처럼 별도 알림을 보내는 경우 생략)
    if (!skipCommentNotification) {
      updateUserNotification({
        data,
        collectionPath,
        sendToMasters: false,
      });
    }
    // --------------------------------------
  }

  if (commentId) {
    // 댓글 수정 (봇 재실행 안 함)
    return ref
      .doc(commentId)
      .set(newData, { merge: true })
      .catch((err) => console.log(err.message));
  }
}

type commentEmotionProps = {
  commentId: string;
  collectionPath: string;
  key: 'emojiHeart' | 'emojiChecked' | 'emojiLove' | 'emojiSad';
  userList: string[]; //prevArr + targetUid
};

export async function updateEmotion({
  commentId,
  collectionPath,
  key,
  userList,
}: commentEmotionProps) {
  const ref = fuego.db.collection(`${collectionPath}`);

  if (commentId) {
    // 댓글 업데이트 수정
    return ref
      .doc(commentId)
      .set({ [key]: userList }, { merge: true })
      .then(() => {
        emitTimelineForceRefresh({
          collectionPath,
          action: 'emotion',
          docId: commentId,
          patch: { [key]: userList } as any,
        });
      })
      .catch((err) => console.log(err.message));
  }
}
